import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import api from '../../Services/api';
import { MdFileOpen,MdEdit, MdRemoveRedEye, MdDelete, MdEditDocument } from "react-icons/md";


import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Grid, MenuItem, Select, FormControl, InputLabel
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';




const statesInIndia = [
    'Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh',
    'Jharkhand','Karnataka', 'Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland',
    'Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal',
    'Andaman and Nicobar Islands','Chandigarh','Dadra and Nagar Haveli and Daman and Diu','Delhi','Ladakh','Lakshadweep','Puducherry'
  ];

  

const CoporateList = () => {

   
      const [editingCorporate, setEditingCorporate] = useState(null);
      const [errors, setErrors] = useState({});
        const[corporates,setCorporates] = useState([]);
      const [loading, setLoading] = useState(true);
      const [originalCorporateData, setOriginalCorporateData] = useState(null);
      const [formData, setFormData] = useState({
        CorporateId: '',
        CorporateName: '',
        CorporatePhone: '',
        CorporatePhone1: '',
        CorporateEmail: '',
        CorporateEmail1: '',
        CorporateAddress: '',
        CorporateState: '',
        type: 'corporate',
        CorporateUserId:'' ,
        CorporatePassword: ''
      });
      const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
    const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
    
    
     useEffect(() => {
        fetchCorporate();
      }, []);
    
      const fetchCorporate = async () => {
        try {
          const response = await api.Corporate.getCorporate();
          setCorporates(response.data.data);
          setLoading(false);
        } catch (error) {
          console.error('Error fetching clients:', error);
          setLoading(false);
        }
      };
    
      const handleEditClick = (value) => {
        setEditingCorporate(value.CorporateId);
        setFormData({ ...value });
        setOriginalCorporateData({ ...value }); 
      };
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
      const handleSave = async () => {
        const isDataChanged = JSON.stringify(formData) !== JSON.stringify(originalCorporateData);

        if (!isDataChanged) {
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage("No changes detected");
          setEditingCorporate();
          return; 
        }
        if(validateForm()){
        try {
            const CorporateId = formData.CorporateId
            const updateCorp = {...formData}
            console.log(updateCorp,"data")
          const response = await api.Corporate.updateCorporateDetails(CorporateId, updateCorp);
          if (response.status === 200) {
           
            setSnackbarOpen(true);
            setSnackbarMessage("Saved Successfully!")
            setEditingCorporate(null);
            fetchCorporate();
          } else {
            
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage("Error in submitting");
    
          }
        } catch (error) {
          console.error('Error saving data:', error);
         
        }
      }
      };
    
      const handleCancel = () => {
        setEditingCorporate(null);
        setErrors({})
      };
    
    const validateForm = ( value ) => {
        const newErrors = {};
        const emailPattern = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/;
        const phonePattern = /^[6789]\d{9}$/;
    
        if (!formData.CorporateName) newErrors.CorporateName = 'Company Name is required';
        if (!formData.CorporateState) newErrors.CorporateState = 'State is required';
        if (!formData.CorporateAddress) newErrors.CorporateAddress = 'Address is required';
        if (!formData.CorporatePhone) {
          newErrors.CorporatePhone = 'Phone number required';
        } else {
        
          const phonePattern = /^[6-9]\d{9}$/;
          if (!phonePattern.test(formData.CorporatePhone)) {
            newErrors.CorporatePhone = 'Invalid phone number, Number should not start with zero(6-9)';
          }
          
          const phoneNumber = String(formData.CorporatePhone);
          if (phoneNumber.length !== 10 || !/^\d{10}$/.test(phoneNumber)) {
            newErrors.CorporatePhone = 'Phone number should be exactly 10 digits';
          }
        }
        if (!emailPattern.test(formData.CorporateEmail)) {
          newErrors.CorporateEmail = formData.CorporateEmail ? 'Invalid email address(ex:text@email.com)' : 'Email address required';
        }
        if (formData.CorporateEmail1 && !emailPattern.test(formData.CorporateEmail1)) {
          newErrors.CorporateEmail1 = 'Invalid email address (e.g., text@email.com)';
        }
        
        if (formData.CorporatePhone1 && !phonePattern.test(formData.CorporatePhone1)) {
          newErrors.CorporatePhone1 = 'Invalid phone number. Number should not start with zero(6-9) and length should be 10';
        }
        

        const selectField = formData.CorporateState;
        if (!selectField) {
          newErrors.selectField = 'Please select State';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };
    
  return (
    <div>
        <>
           <Snackbar
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                
                }}
                severity="success"
                open={snackbarOpen}
                autoHideDuration={2000}
                onClose={() => setSnackbarOpen(false)}
                sx={{
                  marginTop: '2.9%', 
                  marginRight: '7%'
                }}
              >
                <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
              </Snackbar>
              <Snackbar
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                severity="error"
                open={errorSnackbarOpen}
                autoHideDuration={2000}
                sx={{
                  marginTop: '2.9%', 
                  marginRight: '7%'
                }}
                onClose={() => {setErrorSnackbarOpen(false)}}
              >
                <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
              </Snackbar>
              {loading ? (
                  <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
                  <h3>Loading</h3>
         <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div> 
         <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
         <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
         
         </div>
              ) : 
          corporates && corporates.length > 0 ? (
          <div className="m-4">
            <h5>Corporate List <i class="bi bi-arrow-right-square-fill" ></i></h5>
           
              <TableContainer>
                <div style={{ minHeight:"390px",maxHeight: "390px", marginTop:"10px", overflowY: "auto" }}>
                <Table style={{  width: '100%',borderTop:'none' }}>
                  <TableHead className="position-sticky top-0 " style={{zIndex:1000, backgroundColor: 'black', color: 'white', fontWeight: 'bold',borderTop:"none" }}>
                    <TableRow style={{backgroundColor:'black',color:'white'}}>
                      <th className='border-top-0'>Corporate Employer Details</th>
                    
                      <th className='border-top-0'>Action</th>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {corporates.map((value) => (
                      <TableRow key={value.CorporateId}>
                        <TableCell>
                        <div style={{fontSize:"14px",fontWeight:'bold'}}>{value.CorporateName}</div>
                      
                          <div style={{color:'gray'}} >Address : {value.CorporateAddress}, {value.CorporateState}</div>
                          
                          {/* <div style={{color:'gray'}} >Contact Person: {client.authorisedPersonName}</div> */}
                          <div style={{color:'gray'}} >Contact Number : {value.CorporatePhone} {value.CorporatePhone1 && `, ${value.CorporatePhone1}`}</div>
                          <div style={{color:'gray'}} >Email : {value.CorporateEmail} {value.CorporateEmail1 && `, ${value.CorporateEmail1}`}</div>
                        </TableCell>
                     
                        <TableCell className="justify-content-center">
                        <button className="px-1 py-1 border-1 border-blue-600 rounded" title="Edit" onClick={() => handleEditClick(value)}>
                                                            <MdEditDocument className="text-lg text-blue-600" />
                          
                        </button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                </div>
              </TableContainer>
              </div>
          ) : (
            <div className='mt-4'>
              <p className="text-center">No Corporate Details Found !! <Link to="/createcorporate" className="text-danger">Click here</Link> to Create</p>
            </div>
          )}
      
            {/* Edit Dialog Popup */}
            <Dialog open={editingCorporate !== null} onClose={handleCancel} fullWidth maxWidth="md">
            <h6 style={{textAlign:'center',color:'white',backgroundColor:"#1C1C1C",padding:'24px',letterSpacing:'0.5px'}}>EDIT CORPORATE DETAILS</h6>
           
              <DialogContent>
              <Grid container spacing={2}>
  <Grid item xs={12} md={6}>
    <TextField
    className='w-100'
      label="Corporate / Company Name"
      name="CorporateName"
      InputLabelProps={{ shrink: true }}
      value={formData.CorporateName}
      onChange={handleChange}
      error={!!errors.CorporateName}
      helperText={errors.CorporateName}
    />
  </Grid>

  <Grid item xs={12} md={6}>
              <FormControl fullWidth>
    
              <InputLabel id="demo-simple-select-label">Select State</InputLabel>
    <Select
    className='w-100'
      label="Select State"
      value={formData.CorporateState}
      onChange={handleChange}
      InputLabelProps={{ shrink: true }}
      name="CorporateState"
      displayEmpty
      error={!!errors.CorporateState}
    >
   
      {statesInIndia.map((state, index) => (
        <MenuItem key={index} value={state}>{state}</MenuItem>
      ))}
    </Select>
       </FormControl>
    {errors.selectField && (
      <div className="pb-3 px-5" style={{ color: 'red', fontSize: '14px' }}>
        {errors.selectField}
      </div>
    )}
  </Grid>

  <Grid item xs={12} md={6}>
    <TextField
      className='w-100'
      label="Address"
      name="CorporateAddress"
      InputLabelProps={{ shrink: true }}
      value={formData.CorporateAddress}
      onChange={handleChange}
      error={!!errors.CorporateAddress}
      helperText={errors.CorporateAddress}
    />
  </Grid>

  <Grid item xs={12} md={6}>
    <TextField
      className='w-100'
      label="Email"
      InputLabelProps={{ shrink: true }}
      name="CorporateEmail"
      value={formData.CorporateEmail}
      onChange={handleChange}
      error={!!errors.CorporateEmail}
      helperText={errors.CorporateEmail}
    />
  </Grid>

  <Grid item xs={12} md={6}>
    <TextField
      className='w-100'
      type="email"
      label="Alternative Email"
      name="CorporateEmail1"
      InputLabelProps={{ shrink: true }}
      value={formData.CorporateEmail1}
      onChange={handleChange}
      error={!!errors.CorporateEmail1}
      helperText={errors.CorporateEmail1}
    />
  </Grid>

  <Grid item xs={12} md={6}>
    <TextField
      className='w-100'
      label="Contact Number"
      name="CorporatePhone"
      InputLabelProps={{ shrink: true }}
      value={formData.CorporatePhone}
      onChange={handleChange}
      error={!!errors.CorporatePhone}
      helperText={errors.CorporatePhone}
    />
  </Grid>

  <Grid item xs={12} md={6}>
    <TextField
      className='w-100'
    
      label="Alternative Contact Number"
      name="CorporatePhone1"
      InputLabelProps={{ shrink: true }}
      value={formData.CorporatePhone1}
      onChange={handleChange}
      error={!!errors.CorporatePhone1}
      helperText={errors.CorporatePhone1}
    />
  </Grid>
</Grid>

              </DialogContent>
             
              <div className='mx-4 mb-3' style={{display:'flex',justifyContent:'space-between'}}>
                <button className="btn btn-md btn-outline-secondary" onClick={handleCancel} >
                  Cancel
                </button>
                <button className="btn btn-md btn-success" onClick={handleSave} disabled={!validateForm} >
                  Save
                </button>
                </div>
            
            </Dialog>
         
          </>
    </div>
  )
}

export default CoporateList
